import { ComponentAPI } from '../../../api/genericLayout/ComponentAPI';

export class CircleElementStyleCommand {
    constructor(appName) {
        this.componentApi = new ComponentAPI(appName);
    }

    getAvailableTargets(componentType, successCallback, errorCallback) {
        const apiResult = this.componentApi.listCircleElementTargets(componentType);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a obter os elementos disponíveis para configuração de um elemento circular");
            }
        });
    }
}
